import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { FilterListAtomProvider } from './filterList/FilterListAtomProvider';
import { FilterListBottomSheetAtomProvider } from './filterListBottomSheet/FilterListBottomSheetAtomProvider';

const EMPTY_ARRAY: string[] = [];
const PreservedParamKeysContext = createContext<string[]>(EMPTY_ARRAY);
/** 초기화 시 보존할 route param 키 목록 */
export const usePreservedParamKeys = () => useContext(PreservedParamKeysContext);

export const FilterListAtomicProvider = ({
  children,
  preservedParamKeys,
}: {
  children: ReactNode;
  /** 필터 초기화 시 리셋하지 않을 route param 키 목록 */
  preservedParamKeys?: string[];
}) => {
  const keys = useMemo(
    () => preservedParamKeys ?? EMPTY_ARRAY,
    [preservedParamKeys],
  );

  return (
    <PreservedParamKeysContext.Provider value={keys}>
      <FilterListAtomProvider>
        <FilterListBottomSheetAtomProvider>
          {children}
        </FilterListBottomSheetAtomProvider>
      </FilterListAtomProvider>
    </PreservedParamKeysContext.Provider>
  );
};
